import React, { ReactNode } from 'react';
import { NDA_COPIES } from 'models/Nda';
import { t } from 'i18next';
import utils, { getUserFullName } from 'utils';
import {
  TableHeaderKey,
  BossModeTrack,
  BOSS_MODE_TRACK_EVENTS_LABEL,
} from '../../types';

export const BODY_CONTENT_GENERATE: Partial<
  Record<TableHeaderKey, (event: BossModeTrack) => ReactNode>
> = {
  eventType: (event: BossModeTrack) => (
    <div>{t(BOSS_MODE_TRACK_EVENTS_LABEL[event.eventType])}</div>
  ),
  user: (event: BossModeTrack) => (
    <div>{getUserFullName(event.user?.firstName, event.user?.lastName)}</div>
  ),
  listing: (event: BossModeTrack) => <div>{event.listing?.listingTitle}</div>,
  lead: (event: BossModeTrack) => (
    <div>
      {getUserFullName(event.lead?.firstName, event.lead?.lastName) ||
        getUserFullName(event.receiver?.firstName, event.receiver?.lastName)}
    </div>
  ),
  previousNdaStatus: (event: BossModeTrack) => (
    <div>{t(NDA_COPIES[event.previousNdaStatus])}</div>
  ),
  newNdaStatus: (event: BossModeTrack) => (
    <div>{t(NDA_COPIES[event.newNdaStatus])}</div>
  ),
  createdAt: (event: BossModeTrack) => (
    <div>{utils.dateFormat(event.createdAt, 'd/mm/yy h:MMtt')}</div>
  ),
};
